import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class PersonalDataService {
  constructor(private common: CommonService) {}

  /**
   * 获取全部招聘岗位
   */
  async getHeadhuntingJob(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingTool/getHeadhuntingJob',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试官对应的岗位信息
   */
  async getInterviewerJob(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingTool/getInterviewerJob',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取阶段与状态关系列表
   */
  async getStageAndState(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingStatistics/getStageAndState',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 邀约日数据统计-总数据
   */
  async getDailyStatisticsTotal(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingStatistics/getDailyStatisticsTotal',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 邀约日数据统计
   */
  async getInvitationDailyStatistics(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingStatistics/getInvitationDailyStatistics',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取猎头邀约月报数据-总计数据
   */
  async getMonthAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingStatistics/getMonthAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取猎头邀约月报数据
   */
  async getMonthList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingStatistics/getMonthList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取今日面试列表数据
   */
  async getTodayList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInvite/getTodayList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试列表数据
   */
  async getList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInvite/getList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试列表数据-总计
   */
  async getAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInvite/getAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取当前面试官面试的应聘者详情列表
   */
  async getUserList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/interviewInvite/getUserList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
}
